import React from "react";

const logo = "/img/logo.png";

const Hero2 = () => (
  <div className="text-center hero">
    <img className="mb-3 app-logo" src={logo} alt="React logo" width="200" />
    <h1 className="mb-4">Cookies akzeptieren</h1>
    <p className="lead">
      Bitte akzeptiere die Cookies um die App vollstänig nutzen zu können.
    </p>
  </div>
);

export default Hero2;
